module.exports = __webpack_public_path__ + "img/1440.80889f64.jpg";